module.exports = __webpack_public_path__ + "static/img/DoGreatWork_Desktop.8eeb066.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/desktop/landing/DoGreatWork_Desktop.svg
// module id = RxQf
// module chunks = 1